<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">ApiCrypt</div>
        <div class="modal-body">

            <form *ngIf="formGroup" [formGroup]="formGroup" (ngSubmit)="connectToApicrypt()">
                <frg-form-input
                    label="Identifiant National PS"
                    [formGroup]="formGroup"
                    id="account"
                    [control]="formGroup.get('account')"
                    errorMessage="Compte ApiCrypt"
                    required="true"
                    [disabled]="true"
                ></frg-form-input>
                <frg-form-input
                    label="Mot de passe"
                    [formGroup]="formGroup"
                    id="password"
                    [control]="formGroup.get('password')"
                    errorMessage="Le mot de passe est obligatoire"
                    required="true"
                    type="password"
                ></frg-form-input>
                <div class="buttons-wrapper center">
                    <frg-button
                        [disabled]="!formGroup.valid"
                        type="submit"
                        fullWidth="true"
                    >Connexion</frg-button>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-background"></div>